import { render } from "./ModalStartRun.vue?vue&type=template&id=bdf8a4dc"
import script from "./ModalStartRun.vue?vue&type=script&lang=js"
export * from "./ModalStartRun.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__